;(function(){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    model: {
        prop: 'value',
        event: 'change'
    },
    props: ["options", "value", "url", "prompt", "processResultsFun", "csrf_token"],
    data: function data() {
        return {
            current_url: ""
        };
    },

    methods: {
        createSelect2: function createSelect2(url) {
            var vm = this;

            var opts = {
                placeholder: this.prompt || 'Select an option',
                ajax: {
                    url: url,
                    dataType: 'json',
                    autoClear: true,
                    delay: 250,
                    headers: {
                        'X-CSRF-TOKEN': this.csrf_token
                    },
                    data: function data(params) {
                        return {
                            page: params.page || 1,
                            q: params.term
                        };
                    },
                    processResults: vm.processResultsFun || function (data, params) {
                        params.page = params.page || 1;
                        return {
                            results: data.services.map(function (service) {
                                return {
                                    id: service.id,
                                    text: service.name
                                };
                            }),
                            pagination: {
                                more: params.page < data.total_pages
                            }
                        };
                    },
                    cache: true,
                    success: function success(data) {},
                    error: function error(jqXHR, textStatus, errorThrown) {
                        console.error('Error during AJAX call:', textStatus, errorThrown);
                    }
                },
                minimumInputLength: 3
            };

            $(this.$el).select2(opts).val(this.value).trigger('change').on('change', function () {
                vm.$emit('change', $(this).val());
            });

            $(this.$el).val(null).trigger('change');
        }
    },
    mounted: function mounted() {
        this.createSelect2(this.url);
    },

    watch: {
        url: function url(newUrl) {
            this.createSelect2(newUrl);
        }
    },
    beforeDestroy: function beforeDestroy() {
        $(this.$el).off().select2('destroy');
    }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select',{staticClass:"form-control custom_select"},[_vm._v("\n< "),_c('option',{attrs:{"value":""}},[_vm._v("Select by Service")]),_vm._v(" "),_vm._t("default")],2)}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-5bf451c2", __vue__options__)
  } else {
    hotAPI.reload("data-v-5bf451c2", __vue__options__)
  }
})()}